import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import useSnackbar from '../../../hooks/useSnackbar';
import { PushPromotion } from '../../../services/notification';
import { DialogBoxComp } from '../../atoms/DialogBox'; // Adjust the import path as necessary

const PushPromotionalNotification = ({ onSaved, handleDrawerClose }: any) => {
  const [formData, setFormData] = useState({
    title: '',
    body: '',
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const { showSnackbar, SnackbarComponent } = useSnackbar();

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleConfirm = async () => {
    try {
      if (!formData.body || !formData.title) return;
      const status = await PushPromotion({
        title: formData.title,
        body: formData.body,
      });
      if (status === 200) {
        await showSnackbar('Notification Pushed!', 'success');
        setTimeout(() => {
          handleDrawerClose();
          if (onSaved) {
            onSaved(formData); // Trigger the onSaved callback with formData
          }
        }, 500);
      } else {
        showSnackbar('Error: Failed to Push Notification', 'error');
      }
    } catch (error: any) {
      showSnackbar(`Error: ${error.message}`, 'error');
    }
    setDialogOpen(false);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!formData.body || !formData.title) return;
    setDialogOpen(true);
  };

  const handleReset = () => {
    setFormData({
      title: '',
      body: '',
    });
  };

  return (
    <Box sx={{ padding: 0, flex: 1 }}>
      {SnackbarComponent}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="subtitle1">Promotion Title</Typography>
        <TextField
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
          variant="outlined"
        />

        <Typography variant="subtitle1">Promotion Body</Typography>
        <TextField
          name="body"
          value={formData.body}
          multiline
          minRows={4}
          onChange={handleChange}
          required
          variant="outlined"
        />

        <Box sx={{ display: 'flex', gap: 2, mt: 5 }}>
          <Button type="button" variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Run
          </Button>
        </Box>
      </Box>

      <DialogBoxComp
        open={dialogOpen}
        title="Confirm Notification Push"
        content="Are you sure you want to push this notification?"
        handleClose={() => setDialogOpen(false)}
        handleConfirm={handleConfirm}
      />
    </Box>
  );
};

export default PushPromotionalNotification;
